import { hasPlussAccess } from "./planUtils";

const PROTECTED_ENTITLEMENTS = [
  "view_detailed_solution",
  "access_premium_progress_history",
  "access_ai_chat",
];

const LEGACY_PAID_ENTITLEMENTS = PROTECTED_ENTITLEMENTS.filter(
  (entitlement) => entitlement !== "access_ai_chat",
);

const getProtectedEntitlements = (profile) => {
  if (Array.isArray(profile?.entitlements)) {
    const entitlementSet = new Set(profile.entitlements);
    return PROTECTED_ENTITLEMENTS.filter((entitlement) =>
      entitlementSet.has(entitlement),
    );
  }
  return hasPlussAccess(profile?.plan) ? LEGACY_PAID_ENTITLEMENTS : [];
};

export const buildEntitlementCacheScope = (profile) => {
  if (!profile) return "access-pending";
  const protectedEntitlements = getProtectedEntitlements(profile);
  return protectedEntitlements.length
    ? `access-${protectedEntitlements.join("+")}`
    : "access-free";
};

export const hasLostProtectedEntitlement = (previousProfile, nextProfile) => {
  const nextEntitlements = new Set(getProtectedEntitlements(nextProfile));
  return getProtectedEntitlements(previousProfile).some(
    (entitlement) => !nextEntitlements.has(entitlement),
  );
};

export const isEntitlementSensitiveQuery = (query) => {
  const root = query?.queryKey?.[0];
  if (typeof root !== "string") return false;
  return (
    root === "problem" ||
    root === "problems" ||
    root === "ai-usage" ||
    root.startsWith("collection") ||
    root.startsWith("sidebar-collection")
  );
};

export const removeEntitlementSensitiveQueries = (queryClient) => {
  queryClient.removeQueries({ predicate: isEntitlementSensitiveQuery });
};
